<template>
    <div class="select-item-wrapper">
        <div v-for="(item, idx) in itemData" :key="idx" @click="itemClick(item)">
            <span class="select-item-icon">
                <Icon :width="22" :height="20" :bgPosition="item.position" class="item-icon" :class="item.iconClass" />
            </span>
            <p>{{ item.name }}</p>
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "SelectItem",
    props: ["itemData"],
    components: {
        Icon
    },
    data() {
        return {};
    },
    methods: {
        itemClick(item) {
            this.$emit("itemSelect", item);
        }
    }
};
</script>

<style lang="scss" scoped>
.select-item-wrapper {
    width: 200px;
    height: 200px;
    padding: 20px;
    box-sizing: border-box;
    margin-right: 16px;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-content: center;
    flex-wrap: wrap;

    & > div {
        text-align: center;
        margin: 6px 9px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
            color: #2ec2ff;

            .item-icon {
                background-position-y: -74px !important;
            }
            .item-icon.reference-icon {
                background-position-y: -23px !important;
            }
            .item-icon.container-icon {
                background-position-y: 50px !important;
            }
        }
    }

    .select-item-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 2px 6px 0 rgba(46, 98, 151, 0.2);
        border-radius: 50%;
        margin-bottom: 5px;
    }
}
</style>
